<template>
  <!-- 侧边栏区域树 -->
  <div>
    <el-input placeholder="输入关键字进行过滤" v-model="filterText">
      <template slot="append">
        <i
          class="el-icon-plus"
          @click="showCatalogDialog('add')"
          v-if="permissionList.addCatalog"
        ></i>
      </template>
    </el-input>
    <div :style="'height:' + (bodyHeight - 200) + 'px; overflow: scroll; margin-top: 10px;'">
      <el-tree
        v-if="needShowTree && projectId"
        ref="tree"
        node-key="id"
        :expand-on-click-node="false"
        lazy
        :props="treeProps"
        :data="treeData"
        :load="loadNode"
        :filter-node-method="filterNode"
        @node-click="nodeClick"
      >
        <span slot-scope="{ node }" class="custom-tree-node">
          <span style="flex: 3">
            <el-tooltip class="item" effect="dark" :content="node.label" placement="top-start">
              <span>{{
                node.label.length > 10 ? node.label.slice(0, 8) + '...' : node.label
              }}</span>
            </el-tooltip>
          </span>
          <span style="flex: 1" class="menu">
            <el-tooltip class="item" effect="dark" content="新增子目录" placement="top">
              <i
                class="iconfont iconicon_subordinate"
                @click="showCatalogDialog('add', node)"
                v-if="permissionList.addCatalog"
              ></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="编辑" placement="top">
              <i
                class="iconfont iconicon_compile"
                @click="showCatalogDialog('edit', node)"
                v-if="permissionList.editCatalog"
              ></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" placement="top">
              <i
                class="iconfont iconicon_delete"
                @click="doDel(node)"
                v-if="permissionList.delCatalog"
              ></i>
            </el-tooltip>
          </span>
        </span>
      </el-tree>
    </div>
    <!-- 弹框 -->
    <el-dialog
      :title="catalogDialogTitle"
      :visible.sync="catalogDialogShow"
      width="35%"
      append-to-body
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <el-form ref="form" :model="catalogDialogForm" label-width="80px">
        <el-form-item label="上级目录" v-if="catalogDialogTitle == '新增'">
          <el-input v-model="catalogDialogForm.parentName" disabled></el-input>
        </el-form-item>
        <el-form-item label="目录名称">
          <el-input
            v-model="catalogDialogForm.name"
            placeholder="请输入 目录名称"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
        <div style="text-align: right; width: 100%">
          <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="doSave">
            创建
          </el-button>
          <el-button icon="el-icon-remove-outline" size="small" @click="catalogDialogShow = false">
            取消
          </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getProjectListApi } from '@/api/call-system';

export default {
  props: {
    // 操作权限
    permissionList: {
      type: Object,
      default: {
        addCatalog: 'true',
        delCatalog: 'true',
        editCatalog: 'true',
      },
    },
    // 接口api
    apis: {
      type: Object,
      required: true,
      default: {
        list: Promise.resolve(),
        add: Promise.resolve(),
        update: Promise.resolve(),
        del: Promise.resolve(),
      },
    },
    // api附加参数
    exApiParams: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      needShowTree: true,
      projectId: '', // 项目id
      treeData: [], // 树的数据
      // 树的节点属性
      treeProps: {
        label: 'name',
        isLeaf: 'isLeaf',
      },
      filterText: '', // 过滤关键字
      catalogDialogForm: {},
      catalogDialogTitle: '',
      catalogDialogShow: false,
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    getProjectListApi().then(({ data }) => {
      if (data.length > 0) {
        this.projectId = data[0].id;
      }
    });
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    nodeClick(data) {
      this.$emit('updateTreeNode', {
        projectId: this.projectId,
        nodeData: data,
      });
    },
    loadNode(node, resolve) {
      this.apis
        .list(
          Object.assign(
            { parentId: node.data.id || 0, projectId: this.projectId },
            this.exApiParams
          )
        )
        .then(({ data }) => {
          data.forEach((ele) => {
            ele.isLeaf = !ele.hasChildren;
          });
          resolve(data);
          // 如果是刷新整个树，则默认选中第一个节点
          if (node.level == 0) {
            this.$nextTick(() => {
              this.$refs.tree.setCurrentKey(data[0].id);
              this.nodeClick(data[0]);
            });
          }
        });
    },
    /* 显示弹框 */
    showCatalogDialog(type, node) {
      switch (type) {
        case 'add':
          this.catalogDialogTitle = '新增';
          this.catalogDialogForm = {
            projectId: this.projectId,
            parentId: node ? node.data.id : 0,
            parentName: node ? node.data.name : '',
          };
          break;
        case 'edit':
          this.catalogDialogTitle = '编辑';
          this.catalogDialogForm = node.data;
          break;
        default:
      }
      this.catalogDialogShow = true;
    },
    doSave() {
      let fn = this.catalogDialogForm.id ? this.apis.update : this.apis.add;
      fn(this.catalogDialogForm).then(() => {
        this.catalogDialogShow = false;
        this.updateTreeData();
        this.$message.success('操作成功!');
      });
    },
    doDel(node) {
      const id = node.data.id;
      this.$confirm('确认删除？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return this.apis.del({ ids: id });
        })
        .then(() => {
          this.updateTreeData();
          this.$message.success('操作成功!');
        });
    },
    /* 重置树的数据 */
    updateTreeData() {
      this.needShowTree = false;
      this.treeData = [];
      this.$nextTick(() => {
        this.needShowTree = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .custom-tree-node {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  .menu {
    width: 40%;
    position: absolute;
    right: 0;
    opacity: 1;
    display: flex;
    justify-content: space-between;
  }
}
</style>
